export default async function UpdateHierarchyOrderApi(planId, orderIndex) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ orderIndex }),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/${planId}/hierarchy/order`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: "Failed to update hierarchy order" };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: "Failed to update hierarchy order" };
  }

  return res;
} 